(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["four-products-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('resiners-product-tabs')) {
 customElements.define('resiners-product-tabs', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const signal = this.controller.signal;
   const init = () => {
    if (!this.isConnected || signal.aborted) return;
    this.tabs = [...this.querySelectorAll('.rpt-tab')];
    this.panels = [...this.querySelectorAll('.rpt-panel')];
    if (!this.tabs.length) return;
    this.current = 0;
    this.classList.add('rpt-ready');
    this.show(0);
    this.addEventListener('click', e => {
     const tab = e.target.closest('.rpt-tab');
     const arrow = e.target.closest('[data-step]');
     if (tab) this.show(this.tabs.indexOf(tab));
     if (arrow) this.show(this.current + Number(arrow.dataset.step), true);
    }, { signal });
    this.addEventListener('keydown', e => {
     if (!e.target.closest('.rpt-tab')) return;
     const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
     if (!keys.includes(e.key)) return;
     e.preventDefault();
     const index = e.key === 'Home' ? 0 : e.key === 'End' ? this.tabs.length - 1 : this.current + (e.key === 'ArrowRight' ? 1 : -1);
     this.show(index, true);
    }, { signal });
    let start = null;
    this.addEventListener('touchstart', e => {
     start = e.target.closest('.rpt-media') && e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
    }, {signal, passive:true});
    this.addEventListener('touchend', e => {
     if (!start) return;
     const dx = e.changedTouches[0].clientX - start.x;
     const dy = e.changedTouches[0].clientY - start.y;
     if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.show(this.current + (dx < 0 ? 1 : -1));
     start = null;
    }, {signal, passive:true});
    this.addEventListener('touchcancel', () => {start=null;}, {signal, passive:true});
    document.addEventListener('shopify:block:select', e => {
     const index = this.panels.findIndex(panel => panel.dataset.blockId === e.detail.blockId);
     if (index !== -1) this.show(index);
    }, {signal});
   };
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true, signal});
   else queueMicrotask(init);
  }
  disconnectedCallback() { this.controller?.abort(); }
  show(index, focus = false) {
   this.current = (index + this.tabs.length) % this.tabs.length;
   this.tabs.forEach((tab, i) => {
    tab.setAttribute('aria-selected', String(i === this.current));
    tab.tabIndex = i === this.current ? 0 : -1;
    this.panels[i].hidden = i !== this.current;
   });
   if (focus) this.tabs[this.current].focus({preventScroll:true});
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resiners-photo-wall"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('resiners-photo-wall')) {
 customElements.define('resiners-photo-wall', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
   const init=()=>{
    if(signal.aborted || !this.isConnected)return;
    const button=this.querySelector('.rpw-control');if(!button)return;
    const media=window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused=false;
    const sync=()=>{const paused=userPaused || media.matches;this.classList.toggle('rpw-paused',paused);button.setAttribute('aria-pressed',String(paused));button.textContent=paused?this.dataset.play:this.dataset.pause;button.disabled=media.matches;};
    button.addEventListener('click',()=>{userPaused=!userPaused;sync();},{signal});
    media.addEventListener('change',sync,{signal});
    document.addEventListener('shopify:block:select',e=>{const col=[...this.querySelectorAll('.rpw-column')].find(x=>x.dataset.blockId===e.detail.blockId);if(col){this.classList.add('rpw-editing');this.querySelectorAll('.rpw-selected').forEach(x=>x.classList.remove('rpw-selected'));col.classList.add('rpw-selected');}},{signal});
    document.addEventListener('shopify:block:deselect',()=>{this.classList.remove('rpw-editing');this.querySelectorAll('.rpw-selected').forEach(x=>x.classList.remove('rpw-selected'));},{signal});
    this.classList.add('rpw-ready');sync();
   };
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true,signal});else queueMicrotask(init);
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
